import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { findPageIframe } from './framingLive';

// COUVERTURE EN MOSAIQUE (3 photos) : une zone cliquable PAR PHOTO (correctif du 2026-10-16 : « il est impossible de
// modifier chaque photo, on peut uniquement modifier la photo du haut »). Comme CoverTextOverlay, on LIT la position
// des photos dans l'apercu rendu par le serveur (.cvr-photo-zone = grande photo, .cvr-multi-pair figure = les deux
// petites) et on pose un bouton par-dessus ; un clic ouvre le choix de photo POUR CET EMPLACEMENT.
const POLL_MS = 500;

export const isMultiPhotoCover = (html) => typeof html === 'string' && html.includes('cvr-variant-COVER_MULTI_PHOTO');

function readBoxes(root) {
  const iframe = findPageIframe({ face: 'front' });
  let doc = null;
  try { doc = iframe && iframe.contentDocument; } catch (_error) { return null; }
  if (!root || !doc || !doc.body) return null;
  const pageRect = root.getBoundingClientRect();
  const frameRect = iframe.getBoundingClientRect();
  const scale = frameRect.width / (iframe.offsetWidth || 1);
  const elements = [doc.querySelector('.cvr-photo-zone'), ...doc.querySelectorAll('.cvr-multi-pair figure')].slice(0, 3);
  return elements.map((element) => {
    if (!element) return null;
    const rect = element.getBoundingClientRect();
    if (!(rect.width > 0 && rect.height > 0)) return null;
    return {
      left: Math.round(frameRect.left - pageRect.left + rect.left * scale),
      top: Math.round(frameRect.top - pageRect.top + rect.top * scale),
      width: Math.round(rect.width * scale),
      height: Math.round(rect.height * scale)
    };
  });
}

function CoverMultiPhotoOverlay({ html, onPickSlot, activeSlot }) {
  const { t } = useTranslation('atelier');
  const rootRef = useRef(null);
  const [boxes, setBoxes] = useState([]);
  const measure = useCallback(() => {
    const next = readBoxes(rootRef.current) || [];
    setBoxes((previous) => (JSON.stringify(previous) === JSON.stringify(next) ? previous : next));
  }, []);
  useEffect(() => {
    measure();
    const timer = setInterval(measure, POLL_MS);
    window.addEventListener('resize', measure);
    return () => { clearInterval(timer); window.removeEventListener('resize', measure); };
  }, [html, measure]);

  return (
    <div ref={rootRef} className="atelier-cover-multi-overlay" onClick={(event) => event.stopPropagation()}>
      {boxes.map((box, index) => box && (
        <button
          key={index}
          type="button"
          className={`atelier-cover-multi-hit ${activeSlot === index ? 'is-active' : ''}`}
          style={{ left: box.left, top: box.top, width: box.width, height: box.height }}
          aria-label={t('coverMulti.change', { number: index + 1 })}
          onClick={(event) => { event.stopPropagation(); onPickSlot(index); }}
        >
          <span>{t('coverMulti.changeShort')}</span>
        </button>
      ))}
    </div>
  );
}

export default CoverMultiPhotoOverlay;
